export default "__VITE_ASSET__Zie9xt5T__"